<template lang="pug">
  v-slide-y-transition(mode="out-in")
    v-container(fluid v-if="!isLoading()")
      v-form(ref="saleForm", @submit.prevent="handleSubmit")
        v-card(class="mb2")
          v-card-title
            h3.headeline Datos de la oferta

          v-card-text
            v-text-field(:label="$t('Nombre')", v-model="sale.name", :rules="validation.required", required)
            v-select(:label="$t('Categoría')", v-model="sale.category", item-text="name", item-value="id", :rules="validation.required", :items="salesCategories", required)
            v-textarea(:label="$t('Descripción')", v-model="sale.description", required, :rows="2", auto-grow, hint="Se utilizará para posicionamiento y redes sociales")
            v-currency-field(:label="$t('Precio desde')", v-model="sale.price", required)
            v-checkbox(:label="$t('Visible')", v-model="sale.visible")
            div.mb-4
              div.text-h6 Imagen de portada
              img.image(v-if="sale.image", :src="getSaleImageUrl(sale.image)")
              custom-uploader(button-text="Selecciona la imagen de portada", autoupload, @uploaded="handleUploaded", :multiple="false", accept="image/jpeg, image/png", :endpoint="`/upload?path=sales_portrait`")

            div.text-h6.mb-2 Contenido de la oferta
            editor(api-key="bsxvj8j7unf96buqrpyw8h8ubtc4mnxp1ktuwqk88539qcpq", :init="editorConfig", v-model="sale.body", placeholder="Cuerpo de la oferta", required)

          v-card-actions
            v-btn(color="red" dark @click="$router.push('/sales')") Cancelar
            v-spacer
            v-btn(color="primary", type="submit") Guardar

    v-container(fluid fill-height v-else)
      v-layout(flex align-center justify-center)
        v-progress-circular(indeterminate, color="primary", :size="128", :width="2")
</template>

<style scoped>
.image {
  height: 200px;
  margin: 10px 0;
}
</style>

<script>
import Uploader from '@/components/Uploader';
import validation from '@/utils/validation';
import Editor from '@tinymce/tinymce-vue';
import { BASE_URL } from '@/utils/api';

const emptySale = {
  id: null,
  name: '',
  category: null,
  description: null,
  body: null,
  image: null,
};

const STORAGE_HOST = process.env.STORAGE_HOST;

export default {
  components: {
    Editor,
    'custom-uploader': Uploader,
  },
  data() {
    return {
      sale: {},
      salesCategories: [],
      editorConfig: {
        height: '700px',
        plugins: 'print preview paste importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help charmap quickbars',
        toolbar: 'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl',
        images_upload_handler(blobInfo, success, failure, progress) {
          const data = new FormData();
          data.append('file', blobInfo.blob(), blobInfo.filename());

          api.post(`${BASE_URL}/upload?path=sales`, data, {
            onUploadProgress: (progressEvent) => {
              progress((progressEvent.loaded * 100) / progressEvent.total);
            },
          }).then((res) => {
            success(`//${STORAGE_HOST}/${res.data.image}`);
          }).catch((err) => {
            failure(err.message);
          });
        },
      },
      loading: {
        sale: false,
        salesCategories: false,
      },
      validation,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    getSaleImageUrl(image) {
      return `//${STORAGE_HOST}/${image}`;
    },
    isLoading() {
      return this.loading.sale && this.loading.salesCategories;
    },
    fetchData() {
      this.loading.sale = true;
      this.loading.salesCategories = true;

      api.get('/sales_categories').then((res) => {
        this.salesCategories = res.data;
      }).catch(this.handleError)
        .finally(() => { this.loading.salesCategories = false; });

      if (this.$route.params.id) {
        api.get(`/sales/${this.$route.params.id}`).then((res) => {
          this.sale = res.data;
          if (this.sale.category.id) {
            this.sale.category = this.sale.category.id;
          }
        }).catch(this.handleError)
          .finally(() => { this.loading.sale = false; });
      } else {
        this.sale = Object.assign({}, emptySale);
        this.loading.sale = false;
      }
    },
    handleSubmit() {
      if (this.$refs.saleForm.validate()) {
        this.loading.saving = true;
        const data = { ...this.sale };
        data.category = { id: data.category };
        if (this.sale.id === null) {
          api.post('/sales', data).then(() => {
            this.$router.push('/sales');
          }).catch(this.handleError)
            .finally(() => {
              this.loading.saving = false;
            });
        } else {
          api.put(`/sales/${this.sale.id}`, data).then(() => {
            this.$router.push('/sales');
          }).catch(this.handleError)
            .finally(() => {
              this.loading.saving = false;
            });
        }
      }
    },
    handleUploaded({ image }) {
      this.sale.image = image;
      this.$forceUpdate();
    },
    handleError(err) {
        // eslint-disable-next-line no-console
      console.error(err);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Sales/SaleForm.vue